import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
const Footer = () => {
  const { t }: { t: (key: string, options?: any) => string } = useTranslation();

  const listMenu = [
    {
      name: "Trang chủ",
      link: "/",
      icon: <i className="fa-solid fa-house"></i>,
    },
    {
      name: "Rút tiền",
      link: "/rut-tien",
      icon: <i className="fa-solid fa-credit-card"></i>,
    },
    {
      name: "Xu hướng",
      link: "/xu-huong",
      icon: <i className="fa-solid fa-square-poll-vertical"></i>,
    },
    {
      name: "Tôi",
      link: "/account",
      icon: <i className="fa-solid fa-user"></i>,
    },
  ];

  return (
    <div className="footer-web align-content-center">
      <div className="d-flex align-items-center w-100 footer-container">
        {listMenu?.map((item, index) => {
          return (
            <NavLink
              to={item.link}
              key={index}
              className={`footer-item w-100 text-decoration-none d-flex justify-content-center align-items-center`}
            >
              <div
                className={`d-flex gap-0 flex-column align-items-center justify-content-center`}
              >
                <div className="mb-1">{item.icon}</div>
                <span style={{ lineHeight: "1" }}>{t(item.name)}</span>
              </div>
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default Footer;
